import { Gltf } from './GltfTypes';

const EXTENSION_KEY = '_HIT_CLIP';

/**
 * Per-model audio clip played when a projectile or melee swing lands a bone
 * hit on this animated model. Mirrors `Surface.footstepClipId` semantics for
 * animated victims — the *target* of a hit owns the impact sound, so a
 * humanoid declares its "flesh thud," a tin man declares its "metal clang."
 *
 * Stored as root-level GLB extras (not skin extras) because the property is
 * model-level — future non-skinned destructibles (barrels, crates) will
 * carry one too even though they have no skeleton.
 *
 * Shape: `{ clipId: string }` — wrapped so future fields like volume / pitch
 * jitter can be added without a breaking key rename.
 *
 * GLB writing is owned server-side by the Kotlin `ConfigEmbedder` at publish
 * time; the asset-manager never serializes GLBs in-browser.
 */
export function readHitClipExtras(json: Gltf): string | null {
  const raw = json.extras?.[EXTENSION_KEY] as { clipId?: unknown } | undefined;
  if (!raw || typeof raw !== 'object') return null;
  const clipId = raw.clipId;
  return typeof clipId === 'string' && clipId.length > 0 ? clipId : null;
}
